import { TextVariants } from '@lichtblick/theme';
import { ButtonSize } from '@lichtblick/types';

import { Container, StyledLink } from './Textlink.styles';

import { Text } from '../Text/Text';

type TextlinkProps = {
  href?: string;
  icon?: React.ReactElement;
  onClick?: () => void;
  size?: ButtonSize;
  text: string;
};

export const Textlink = ({ href, icon, onClick, size = 'large', text }: TextlinkProps) => (
  <Container onClick={onClick}>
    {icon}
    {href ? (
      <StyledLink href={href} size={size}>
        {text}
      </StyledLink>
    ) : (
      <Text $variant={TextVariants.button.m}>{text}</Text>
    )}
  </Container>
);
